/** 여러 fetch 레이어를 오른쪽부터 안쪽으로 접어 단일 레이어로 합성한다. */
export function composeLayers(...layers) {
    return (inner) => layers.reduceRight((acc, layer) => layer(acc), inner);
}
//# sourceMappingURL=compose.js.map